import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faBath, faCamera } from '@fortawesome/free-solid-svg-icons';
import './shop-grid.css';
import './PropertyList.css';

const ResultsPage = () => {
  const [products, setProducts] = useState([]);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [searchParams] = useSearchParams();
  const { searchTerm } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const filterss = location.state || {};

  console.log("🔍 Paramètre reçu dans ResultsPage :", searchTerm);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions([]);
      return;
    }
    
    const fetchSuggestions = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/search-predictive', {
          params: { query },
        });
        setSuggestions(response.data);
      } catch (error) {
        console.error('❌ Erreur lors de la récupération des suggestions', error);
      }
    };
    
    fetchSuggestions();
  }, [query]);

  useEffect(() => {
    if (!searchTerm) return;
    
    console.log("📡 Envoi de la requête API avec :", searchTerm);
    
    const fetchResults = async () => {
      try {
        const response = await axios.get('https://keurgui-backend-kjour.ondigitalocean.app/api/products', {
          params: { search: searchTerm },
        });
        console.log("✅ Résultats reçus :", response.data);
        setProducts(response.data);
      } catch (error) {
        console.error("❌ Erreur lors de la récupération des résultats :", error);
      }
    };
    
    fetchResults();
  }, [searchTerm]);

  const handleProductClick = (productId) => navigate(`/product-details/${productId}`);
  const handleImageClick = (productId) => navigate(`/property-images/${productId}`);

  return (
    <div className="results-container">
      <input
        type="text"
        placeholder="Chercher par ville, quartier, région, adresse ou N° Keurgui"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="input-style"
      />
      
      {query.length >= 3 && (
        <div className="search-results-container">
          {suggestions.length > 0 ? (
            suggestions.map((item, index) => (
              <div key={index} className="result-card" onClick={() => navigate(`/results/${encodeURIComponent(item)}`)}>
                <div className="result-card-content">
                  <h5>{item}</h5>
                </div>
              </div>
            ))
          ) : (
            <div className="result-card">
              <div className="result-card-content">
                <h5 style={{ color: "red" }}>Aucun Résultat</h5>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="row">
        {products.length > 0 ? (
          products.map((product) => (
            <div key={product._id} className="col-lg-3 col-sm-6 col-12">
              <div className="result-card">
                <div className="image-container" onClick={() => handleProductClick(product._id)}>
                  <img
                    src={product.images?.[0] || '/path/to/default-image.jpg'}
                    alt={product.title || "Image indisponible"}
                    className="property-image"
                  />
                  <div className="icon-wrapper" onClick={(e) => { e.stopPropagation(); handleImageClick(product._id); }}>
                    <FontAwesomeIcon icon={faCamera} className="photo-icon" />
                    <span className="photo-count">{product.images?.length || 0}</span>
                  </div>
                </div>
                <div className="property-details">
                  <h3>{product.title || "Titre indisponible"}</h3>
                  <p>{product.address || "Adresse inconnue"}, {product.city || "Ville inconnue"}</p>
                  <p>Prix : {product.price ? `${product.price} FCFA` : "Non spécifié"}</p>
                  <div className="features">
                    <span><FontAwesomeIcon icon={faBed} /> {product.features?.bedrooms || 0}</span>
                    <span><FontAwesomeIcon icon={faBath} /> {product.features?.bathrooms || 0}</span>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="no-results">❌ Aucun résultat trouvé.</p>
        )}
      </div>
    </div>
  );
};

export default ResultsPage;
